const PRE_BOOKING_CONTACT_BLOCK_ERROR_MESSAGE =
  "You're not allowed to share this message before the booking is confirmed. Please avoid sharing contact details (phone numbers, LINE IDs, WhatsApp, email addresses, website links, or social handles) until after your booking has been confirmed on SceneAccess.";

const PRE_BOOKING_CONTACT_BLOCK_ERROR_NAME = 'PreBookingContactInfoBlockedError';
const PRE_BOOKING_CONTACT_BLOCK_ERROR_CODE = 'pre_booking_contact_info_blocked';

const BOOKING_PROCESS_NAME = 'default-booking';
const INQUIRY_PROCESS_NAME = 'default-inquiry';
const LEGACY_PAY_LATER_PROCESS_NAMES = ['mobile-banking', 'promptpay'];
const PAY_LATER_PAYMENT_METHODS = ['promptpay', 'mobile_banking', 'mobile-banking'];

const transitions = {
  INQUIRE: 'transition/inquire',
  SEND_CUSTOM_OFFER: 'transition/send-custom-offer',
  WITHDRAW_CUSTOM_OFFER: 'transition/withdraw-custom-offer',
  DECLINE_CUSTOM_OFFER: 'transition/decline-custom-offer',
  ACCEPT_CUSTOM_OFFER: 'transition/accept-custom-offer',
  EXPIRE_CUSTOM_OFFER: 'transition/expire-custom-offer',
  REQUEST_PAYMENT: 'transition/request-payment',
  REQUEST_PAY_LATER_PAYMENT: 'transition/request-pay-later-payment',
  REQUEST_PAYMENT_AFTER_INQUIRY: 'transition/request-payment-after-inquiry',
  REQUEST_PAY_LATER_PAYMENT_AFTER_INQUIRY: 'transition/request-pay-later-payment-after-inquiry',
  REQUEST_CUSTOM_OFFER_PAYMENT_AFTER_INQUIRY:
    'transition/request-custom-offer-payment-after-inquiry',
  REQUEST_CUSTOM_OFFER_PAY_LATER_PAYMENT_AFTER_INQUIRY:
    'transition/request-custom-offer-pay-later-payment-after-inquiry',
  CONFIRM_PAYMENT: 'transition/confirm-payment',
  OPERATOR_CONFIRM_PAYMENT: 'transition/operator-confirm-payment',
  CONFIRM_CUSTOM_OFFER_PAYMENT: 'transition/confirm-custom-offer-payment',
  OPERATOR_CONFIRM_CUSTOM_OFFER_PAYMENT: 'transition/operator-confirm-custom-offer-payment',
  COMPLETE_CUSTOM_OFFER_PAYMENT: 'transition/complete-custom-offer-payment',
  CONFIRM_CUSTOM_OFFER_PAY_LATER_PAYMENT: 'transition/confirm-custom-offer-pay-later-payment',
  CONFIRM_PAY_LATER_PAYMENT: 'transition/confirm-pay-later-payment',
  OPERATOR_CONFIRM_PAY_LATER_PAYMENT: 'transition/operator-confirm-pay-later-payment',
  EXPIRE_PAYMENT: 'transition/expire-payment',
  PAYMENT_FAILED: 'transition/payment-failed',
  RETRY_PAYMENT_AFTER_FAILED: 'transition/retry-payment-after-failed',
  RETRY_PAY_LATER_PAYMENT_AFTER_FAILED: 'transition/retry-pay-later-payment-after-failed',
  RETRY_CUSTOM_OFFER_PAYMENT_AFTER_FAILED: 'transition/retry-custom-offer-payment-after-failed',
  RETRY_CUSTOM_OFFER_PAY_LATER_PAYMENT_AFTER_FAILED:
    'transition/retry-custom-offer-pay-later-payment-after-failed',
  OPERATOR_EXPIRE_PAYMENT: 'transition/operator-expire-payment',
  ACCEPT: 'transition/accept',
  ACCEPT_PAY_LATER: 'transition/accept-pay-later',
  DECLINE: 'transition/decline',
  DECLINE_PAY_LATER: 'transition/decline-pay-later',
  OPERATOR_ACCEPT: 'transition/operator-accept',
  OPERATOR_ACCEPT_PAY_LATER: 'transition/operator-accept-pay-later',
  OPERATOR_DECLINE: 'transition/operator-decline',
  OPERATOR_DECLINE_PAY_LATER: 'transition/operator-decline-pay-later',
  ACCEPTANCE_WINDOW_PASSED: 'transition/acceptance-window-passed',
  PAY_LATER_ACCEPTANCE_WINDOW_PASSED: 'transition/pay-later-acceptance-window-passed',
  OPERATOR_ACCEPTANCE_WINDOW_PASSED: 'transition/operator-acceptance-window-passed',
  OPERATOR_PAY_LATER_ACCEPTANCE_WINDOW_PASSED:
    'transition/operator-pay-later-acceptance-window-passed',
  AUTO_DECLINE_BOOKING_TIME_STARTS: 'transition/auto-decline-booking-time-starts',
  PAYMNENT_WINDOW_PASSED: 'transition/payment-window-passed',
  OPERATOR_PAYMNENT_WINDOW_PASSED: 'transition/operator-payment-window-passed',
  EXPIRE: 'transition/expire',
  CANCEL: 'transition/cancel',
  CANCEL_BY_CUSTOMER: 'transition/cancel-by-customer',
  CANCEL_BY_PROVIDER: 'transition/cancel-by-provider',
  CANCEL_BOOKING_REQUEST_PAYMENT: 'transition/cancel-booking-request-payment',
  CANCEL_BOOKING_REQUEST: 'transition/cancel-booking-request',
  CANCEL_PAY_LATER_BOOKING_REQUEST: 'transition/cancel-pay-later-booking-request',
  RESCHEDULE_BOOKING: 'transition/reschedule-booking',
  ACCEPT_RESCHEDULE_BOOKING: 'transition/accept-reschedule-booking',
  DECLINE_RESCHEDULE_BOOKING: 'transition/decline-reschedule-booking',
  AUTO_COMPLETE_AFTER_RESCHEDULE_BOOKING: 'transition/auto-complete-after-reschedule-booking',
  OPERATOR_COMPLETE_AFTER_RESCHEDULE_BOOKING:
    'transition/operator-complete-after-reschedule-booking',
  COMPLETE: 'transition/complete',
  OPERATOR_COMPLETE: 'transition/operator-complete',
  COMPLETE_AFTER_CANCEL: 'transition/complete-after-cancel',
  OPERATOR_COMPLETE_AFTER_CANCEL: 'transition/operator-complete-after-cancel',
  REQUEST_ACCOUNT_INFO_BY_PROVIDER: 'transition/request-account-info-by-provider',
  ADD_ACCOUNT_INFO_BY_CUSTOMER: 'transition/add-account-info-by-customer',
  DISPUTE: 'transition/dispute',
  OPERATOR_DISPUTE: 'transition/operator-dispute',
  AUTO_CANCEL_FROM_DISPUTED: 'transition/auto-cancel-from-disputed',
  CANCEL_FROM_DISPUTED: 'transition/cancel-from-disputed',
  MARK_RECEIVED_FROM_DISPUTED: 'transition/mark-received-from-disputed',
  PAYOUT_COMPLETE: 'transition/payout-complete',
  OPERATOR_PAYOUT_COMPLETE: 'transition/operator-payout-complete',
  REVIEW_1_BY_PROVIDER: 'transition/review-1-by-provider',
  REVIEW_2_BY_PROVIDER: 'transition/review-2-by-provider',
  REVIEW_1_BY_CUSTOMER: 'transition/review-1-by-customer',
  REVIEW_2_BY_CUSTOMER: 'transition/review-2-by-customer',
  EXPIRE_CUSTOMER_REVIEW_PERIOD: 'transition/expire-customer-review-period',
  EXPIRE_PROVIDER_REVIEW_PERIOD: 'transition/expire-provider-review-period',
  EXPIRE_REVIEW_PERIOD: 'transition/expire-review-period',
};

const states = {
  INITIAL: 'initial',
  INQUIRY: 'inquiry',
  PENDING_PAYMENT: 'pending-payment',
  PENDING_PROVIDER_ACCEPTANCE: 'pending-provider-acceptance',
  PAYMENT_EXPIRED: 'payment-expired',
  PREAUTHORIZED: 'preauthorized',
  BOOKING_RESCHEDULED: 'booking-rescheduled',
  DECLINED: 'declined',
  ACCOUNT_DETAILS_REQUESTED: 'account-details-requested',
  ACCEPTED_PENDING_PAYMENT: 'accepted-pending-payment',
  ACCEPTED: 'accepted',
  EXPIRED: 'expired',
  CANCELLED: 'cancelled',
  COMPLETED: 'completed',
  DISPUTED: 'disputed',
  DELIVERED: 'delivered',
  REVIEWED: 'reviewed',
  REVIEWED_BY_CUSTOMER: 'reviewed-by-customer',
  REVIEWED_BY_PROVIDER: 'reviewed-by-provider',
};

// This mirrors default-booking's state graph closely enough for the contact-sharing gate.
const bookingGraph = {
  [states.INITIAL]: {
    [transitions.INQUIRE]: states.INQUIRY,
    [transitions.REQUEST_PAYMENT]: states.PENDING_PAYMENT,
    [transitions.REQUEST_PAY_LATER_PAYMENT]: states.PENDING_PROVIDER_ACCEPTANCE,
  },
  [states.INQUIRY]: {
    [transitions.SEND_CUSTOM_OFFER]: states.INQUIRY,
    [transitions.WITHDRAW_CUSTOM_OFFER]: states.INQUIRY,
    [transitions.DECLINE_CUSTOM_OFFER]: states.INQUIRY,
    [transitions.ACCEPT_CUSTOM_OFFER]: states.INQUIRY,
    [transitions.EXPIRE_CUSTOM_OFFER]: states.INQUIRY,
    [transitions.REQUEST_PAYMENT_AFTER_INQUIRY]: states.PENDING_PAYMENT,
    [transitions.REQUEST_PAY_LATER_PAYMENT_AFTER_INQUIRY]: states.PENDING_PROVIDER_ACCEPTANCE,
    [transitions.REQUEST_CUSTOM_OFFER_PAYMENT_AFTER_INQUIRY]: states.PENDING_PAYMENT,
    [transitions.REQUEST_CUSTOM_OFFER_PAY_LATER_PAYMENT_AFTER_INQUIRY]:
      states.PENDING_PROVIDER_ACCEPTANCE,
  },
  [states.PENDING_PAYMENT]: {
    [transitions.CANCEL_BOOKING_REQUEST_PAYMENT]: states.CANCELLED,
    [transitions.EXPIRE_PAYMENT]: states.PAYMENT_EXPIRED,
    [transitions.PAYMENT_FAILED]: states.PAYMENT_EXPIRED,
    [transitions.CONFIRM_PAYMENT]: states.PREAUTHORIZED,
    [transitions.OPERATOR_CONFIRM_PAYMENT]: states.PREAUTHORIZED,
    [transitions.CONFIRM_CUSTOM_OFFER_PAYMENT]: states.PREAUTHORIZED,
    [transitions.OPERATOR_CONFIRM_CUSTOM_OFFER_PAYMENT]: states.PREAUTHORIZED,
  },
  [states.PENDING_PROVIDER_ACCEPTANCE]: {
    [transitions.CANCEL_PAY_LATER_BOOKING_REQUEST]: states.CANCELLED,
    [transitions.CONFIRM_CUSTOM_OFFER_PAY_LATER_PAYMENT]: states.ACCEPTED,
    [transitions.ACCEPT_PAY_LATER]: states.ACCEPTED_PENDING_PAYMENT,
    [transitions.OPERATOR_ACCEPT_PAY_LATER]: states.ACCEPTED_PENDING_PAYMENT,
    [transitions.DECLINE_PAY_LATER]: states.DECLINED,
    [transitions.OPERATOR_DECLINE_PAY_LATER]: states.DECLINED,
    [transitions.PAY_LATER_ACCEPTANCE_WINDOW_PASSED]: states.EXPIRED,
    [transitions.AUTO_DECLINE_BOOKING_TIME_STARTS]: states.DECLINED,
    [transitions.OPERATOR_PAY_LATER_ACCEPTANCE_WINDOW_PASSED]: states.EXPIRED,
  },
  [states.PAYMENT_EXPIRED]: {
    [transitions.RETRY_PAYMENT_AFTER_FAILED]: states.PENDING_PAYMENT,
    [transitions.RETRY_PAY_LATER_PAYMENT_AFTER_FAILED]: states.PENDING_PROVIDER_ACCEPTANCE,
    [transitions.RETRY_CUSTOM_OFFER_PAYMENT_AFTER_FAILED]: states.PENDING_PAYMENT,
    [transitions.RETRY_CUSTOM_OFFER_PAY_LATER_PAYMENT_AFTER_FAILED]:
      states.PENDING_PROVIDER_ACCEPTANCE,
  },
  [states.PREAUTHORIZED]: {
    [transitions.CANCEL_BOOKING_REQUEST]: states.CANCELLED,
    [transitions.DECLINE]: states.DECLINED,
    [transitions.OPERATOR_DECLINE]: states.DECLINED,
    [transitions.EXPIRE]: states.EXPIRED,
    [transitions.ACCEPT]: states.ACCEPTED,
    [transitions.OPERATOR_ACCEPT]: states.ACCEPTED,
    [transitions.COMPLETE_CUSTOM_OFFER_PAYMENT]: states.ACCEPTED,
    [transitions.ACCEPTANCE_WINDOW_PASSED]: states.DECLINED,
    [transitions.AUTO_DECLINE_BOOKING_TIME_STARTS]: states.DECLINED,
    [transitions.OPERATOR_ACCEPTANCE_WINDOW_PASSED]: states.DECLINED,
  },
  [states.ACCEPTED_PENDING_PAYMENT]: {
    [transitions.CONFIRM_PAY_LATER_PAYMENT]: states.ACCEPTED,
    [transitions.OPERATOR_CONFIRM_PAY_LATER_PAYMENT]: states.ACCEPTED,
    [transitions.OPERATOR_EXPIRE_PAYMENT]: states.PAYMENT_EXPIRED,
    [transitions.PAYMNENT_WINDOW_PASSED]: states.CANCELLED,
    [transitions.OPERATOR_PAYMNENT_WINDOW_PASSED]: states.CANCELLED,
  },
  [states.ACCEPTED]: {
    [transitions.REQUEST_ACCOUNT_INFO_BY_PROVIDER]: states.ACCOUNT_DETAILS_REQUESTED,
    [transitions.CANCEL]: states.CANCELLED,
    [transitions.CANCEL_BY_CUSTOMER]: states.CANCELLED,
    [transitions.CANCEL_BY_PROVIDER]: states.CANCELLED,
    [transitions.RESCHEDULE_BOOKING]: states.BOOKING_RESCHEDULED,
    [transitions.COMPLETE]: states.COMPLETED,
    [transitions.OPERATOR_COMPLETE]: states.COMPLETED,
  },
  [states.ACCOUNT_DETAILS_REQUESTED]: {
    [transitions.ADD_ACCOUNT_INFO_BY_CUSTOMER]: states.CANCELLED,
  },
  [states.COMPLETED]: {
    [transitions.DISPUTE]: states.DISPUTED,
    [transitions.OPERATOR_DISPUTE]: states.DISPUTED,
    [transitions.PAYOUT_COMPLETE]: states.DELIVERED,
    [transitions.OPERATOR_PAYOUT_COMPLETE]: states.DELIVERED,
  },
  [states.DISPUTED]: {
    [transitions.MARK_RECEIVED_FROM_DISPUTED]: states.DELIVERED,
    [transitions.CANCEL_FROM_DISPUTED]: states.CANCELLED,
    [transitions.AUTO_CANCEL_FROM_DISPUTED]: states.CANCELLED,
  },
  [states.BOOKING_RESCHEDULED]: {
    [transitions.ACCEPT_RESCHEDULE_BOOKING]: states.ACCEPTED,
    [transitions.OPERATOR_COMPLETE_AFTER_RESCHEDULE_BOOKING]: states.COMPLETED,
    [transitions.AUTO_COMPLETE_AFTER_RESCHEDULE_BOOKING]: states.COMPLETED,
    [transitions.DECLINE_RESCHEDULE_BOOKING]: states.ACCEPTED,
  },
  [states.CANCELLED]: {
    [transitions.COMPLETE_AFTER_CANCEL]: states.DELIVERED,
    [transitions.OPERATOR_COMPLETE_AFTER_CANCEL]: states.DELIVERED,
  },
  [states.DELIVERED]: {
    [transitions.EXPIRE_REVIEW_PERIOD]: states.REVIEWED,
    [transitions.REVIEW_1_BY_CUSTOMER]: states.REVIEWED_BY_CUSTOMER,
    [transitions.REVIEW_1_BY_PROVIDER]: states.REVIEWED_BY_PROVIDER,
  },
  [states.REVIEWED_BY_CUSTOMER]: {
    [transitions.REVIEW_2_BY_PROVIDER]: states.REVIEWED,
    [transitions.EXPIRE_PROVIDER_REVIEW_PERIOD]: states.REVIEWED,
  },
  [states.REVIEWED_BY_PROVIDER]: {
    [transitions.REVIEW_2_BY_CUSTOMER]: states.REVIEWED,
    [transitions.EXPIRE_CUSTOMER_REVIEW_PERIOD]: states.REVIEWED,
  },
};

const postAcceptedTransitions = new Set([
  transitions.CANCEL,
  transitions.CANCEL_BY_CUSTOMER,
  transitions.CANCEL_BY_PROVIDER,
  transitions.RESCHEDULE_BOOKING,
  transitions.ACCEPT_RESCHEDULE_BOOKING,
  transitions.DECLINE_RESCHEDULE_BOOKING,
  transitions.AUTO_COMPLETE_AFTER_RESCHEDULE_BOOKING,
  transitions.OPERATOR_COMPLETE_AFTER_RESCHEDULE_BOOKING,
  transitions.COMPLETE,
  transitions.OPERATOR_COMPLETE,
  transitions.COMPLETE_AFTER_CANCEL,
  transitions.OPERATOR_COMPLETE_AFTER_CANCEL,
  transitions.REQUEST_ACCOUNT_INFO_BY_PROVIDER,
  transitions.ADD_ACCOUNT_INFO_BY_CUSTOMER,
  transitions.DISPUTE,
  transitions.OPERATOR_DISPUTE,
  transitions.AUTO_CANCEL_FROM_DISPUTED,
  transitions.CANCEL_FROM_DISPUTED,
  transitions.MARK_RECEIVED_FROM_DISPUTED,
  transitions.PAYOUT_COMPLETE,
  transitions.OPERATOR_PAYOUT_COMPLETE,
  transitions.REVIEW_1_BY_PROVIDER,
  transitions.REVIEW_2_BY_PROVIDER,
  transitions.REVIEW_1_BY_CUSTOMER,
  transitions.REVIEW_2_BY_CUSTOMER,
  transitions.EXPIRE_CUSTOMER_REVIEW_PERIOD,
  transitions.EXPIRE_PROVIDER_REVIEW_PERIOD,
  transitions.EXPIRE_REVIEW_PERIOD,
]);

const normalizeId = value => {
  if (!value) return null;
  if (typeof value === 'string') return value.trim() || null;
  if (value.uuid) return String(value.uuid).trim() || null;
  if (value.id) return normalizeId(value.id);
  if (value.data) return normalizeId(value.data);
  return String(value).trim() || null;
};

const normalizeProcessName = processName =>
  String(processName || '')
    .trim()
    .split('/')[0];

const resolveProcessName = processName => {
  const normalized = normalizeProcessName(processName);
  if (LEGACY_PAY_LATER_PROCESS_NAMES.includes(normalized)) {
    return BOOKING_PROCESS_NAME;
  }
  return normalized;
};

const getPaymentMethod = transaction =>
  transaction?.attributes?.metadata?.paymentMethod ||
  transaction?.attributes?.protectedData?.paymentMethod ||
  (LEGACY_PAY_LATER_PROCESS_NAMES.includes(
    normalizeProcessName(transaction?.attributes?.processName)
  )
    ? normalizeProcessName(transaction?.attributes?.processName)
    : null);

const isPayLaterTransaction = transaction =>
  PAY_LATER_PAYMENT_METHODS.includes(getPaymentMethod(transaction));

const getTransitionHistory = transaction => {
  const history = Array.isArray(transaction?.attributes?.transitions)
    ? transaction.attributes.transitions
    : [];
  const lastTransition = transaction?.attributes?.lastTransition;
  const lastHistoryTransition = history[history.length - 1]?.transition;
  const historyWithLast =
    lastTransition && lastHistoryTransition !== lastTransition
      ? [
          ...history,
          {
            transition: lastTransition,
            createdAt: transaction?.attributes?.lastTransitionedAt,
          },
        ]
      : history;

  return historyWithLast.filter(entry => entry?.transition);
};

const sortTransitionsByCreatedAt = transitionHistory =>
  [...transitionHistory].sort((a, b) => {
    const aTime = a?.createdAt ? new Date(a.createdAt).getTime() : NaN;
    const bTime = b?.createdAt ? new Date(b.createdAt).getTime() : NaN;
    if (Number.isNaN(aTime) || Number.isNaN(bTime)) {
      return 0;
    }
    return aTime - bTime;
  });

const getPayLaterNextState = (transaction, currentState, transition) => {
  if (!isPayLaterTransaction(transaction)) {
    return null;
  }

  if (currentState === states.INITIAL && transition === transitions.REQUEST_PAYMENT) {
    return states.PENDING_PROVIDER_ACCEPTANCE;
  }

  if (currentState === states.INQUIRY && transition === transitions.REQUEST_PAYMENT_AFTER_INQUIRY) {
    return states.PENDING_PROVIDER_ACCEPTANCE;
  }

  if (
    currentState === states.PENDING_PROVIDER_ACCEPTANCE &&
    (transition === transitions.ACCEPT || transition === transitions.OPERATOR_ACCEPT)
  ) {
    return states.ACCEPTED_PENDING_PAYMENT;
  }

  if (
    currentState === states.PENDING_PROVIDER_ACCEPTANCE &&
    (transition === transitions.DECLINE || transition === transitions.OPERATOR_DECLINE)
  ) {
    return states.DECLINED;
  }

  if (
    currentState === states.PENDING_PROVIDER_ACCEPTANCE &&
    (transition === transitions.ACCEPTANCE_WINDOW_PASSED ||
      transition === transitions.OPERATOR_ACCEPTANCE_WINDOW_PASSED)
  ) {
    return states.EXPIRED;
  }

  if (
    currentState === states.ACCEPTED_PENDING_PAYMENT &&
    (transition === transitions.CONFIRM_PAYMENT ||
      transition === transitions.OPERATOR_CONFIRM_PAYMENT)
  ) {
    return states.ACCEPTED;
  }

  return null;
};

const getFallbackState = (transaction, transition) => {
  if (isPayLaterTransaction(transaction)) {
    switch (transition) {
      case transitions.REQUEST_PAYMENT:
      case transitions.REQUEST_PAYMENT_AFTER_INQUIRY:
      case transitions.RETRY_PAYMENT_AFTER_FAILED:
        return states.PENDING_PROVIDER_ACCEPTANCE;
      case transitions.ACCEPT:
      case transitions.OPERATOR_ACCEPT:
      case transitions.ACCEPT_PAY_LATER:
      case transitions.OPERATOR_ACCEPT_PAY_LATER:
        return states.ACCEPTED_PENDING_PAYMENT;
      case transitions.CONFIRM_PAYMENT:
      case transitions.OPERATOR_CONFIRM_PAYMENT:
      case transitions.CONFIRM_PAY_LATER_PAYMENT:
      case transitions.OPERATOR_CONFIRM_PAY_LATER_PAYMENT:
        return states.ACCEPTED;
      default:
        return null;
    }
  }

  switch (transition) {
    case transitions.ACCEPT:
    case transitions.OPERATOR_ACCEPT:
      return states.ACCEPTED;
    case transitions.ACCEPT_PAY_LATER:
    case transitions.OPERATOR_ACCEPT_PAY_LATER:
      return states.ACCEPTED_PENDING_PAYMENT;
    case transitions.CONFIRM_PAYMENT:
    case transitions.OPERATOR_CONFIRM_PAYMENT:
    case transitions.CONFIRM_CUSTOM_OFFER_PAYMENT:
    case transitions.OPERATOR_CONFIRM_CUSTOM_OFFER_PAYMENT:
      return states.PREAUTHORIZED;
    case transitions.CONFIRM_PAY_LATER_PAYMENT:
    case transitions.OPERATOR_CONFIRM_PAY_LATER_PAYMENT:
    case transitions.COMPLETE_CUSTOM_OFFER_PAYMENT:
    case transitions.CONFIRM_CUSTOM_OFFER_PAY_LATER_PAYMENT:
      return states.ACCEPTED;
    case transitions.SEND_CUSTOM_OFFER:
    case transitions.WITHDRAW_CUSTOM_OFFER:
    case transitions.DECLINE_CUSTOM_OFFER:
    case transitions.ACCEPT_CUSTOM_OFFER:
    case transitions.EXPIRE_CUSTOM_OFFER:
      return states.INQUIRY;
    default:
      return postAcceptedTransitions.has(transition) ? states.ACCEPTED : null;
  }
};

const getBookingContactSharingState = transaction => {
  const processName = resolveProcessName(transaction?.attributes?.processName);
  if (processName !== BOOKING_PROCESS_NAME) {
    return {
      applies: processName === INQUIRY_PROCESS_NAME,
      processState: processName === INQUIRY_PROCESS_NAME ? 'free-inquiry' : null,
      hasBookingBeenConfirmed: false,
    };
  }

  const transitionHistory = getTransitionHistory(transaction);
  if (!transitionHistory.length) {
    return { applies: true, processState: null, hasBookingBeenConfirmed: false };
  }

  const resolved = sortTransitionsByCreatedAt(transitionHistory).reduce(
    (acc, transitionEntry) => {
      const transition = transitionEntry?.transition;
      const nextState =
        getPayLaterNextState(transaction, acc.processState, transition) ||
        bookingGraph[acc.processState]?.[transition] ||
        null;

      if (!nextState) {
        return acc;
      }

      return {
        processState: nextState,
        hasBookingBeenConfirmed:
          acc.hasBookingBeenConfirmed ||
          nextState === states.ACCEPTED ||
          postAcceptedTransitions.has(transition),
      };
    },
    { processState: states.INITIAL, hasBookingBeenConfirmed: false }
  );

  if (resolved.processState !== states.INITIAL) {
    return { applies: true, ...resolved };
  }

  const fallbackState = getFallbackState(transaction, transaction?.attributes?.lastTransition);
  return {
    applies: true,
    processState: fallbackState,
    hasBookingBeenConfirmed:
      fallbackState === states.ACCEPTED ||
      postAcceptedTransitions.has(transaction?.attributes?.lastTransition),
  };
};

const isBookingConfirmedForContactSharing = transaction =>
  getBookingContactSharingState(transaction).hasBookingBeenConfirmed;

const getProviderUserId = transaction =>
  normalizeId(transaction?.provider) ||
  normalizeId(transaction?.relationships?.provider?.data) ||
  normalizeId(transaction?.attributes?.protectedData?.providerId);

const getCustomerUserId = transaction =>
  normalizeId(transaction?.customer) ||
  normalizeId(transaction?.relationships?.customer?.data) ||
  normalizeId(transaction?.attributes?.protectedData?.customerId);

const isProviderSender = ({ transaction, currentUser, senderUserId }) => {
  const providerUserId = getProviderUserId(transaction);
  const userId = normalizeId(senderUserId) || normalizeId(currentUser);
  return !!providerUserId && !!userId && providerUserId === userId;
};

const isTransactionParticipantSender = ({ transaction, currentUser, senderUserId }) => {
  const providerUserId = getProviderUserId(transaction);
  const customerUserId = getCustomerUserId(transaction);
  const userId = normalizeId(senderUserId) || normalizeId(currentUser);
  return !!userId && (providerUserId === userId || customerUserId === userId);
};

const createPreBookingContactBlockError = () => {
  const error = new Error(PRE_BOOKING_CONTACT_BLOCK_ERROR_MESSAGE);
  error.name = PRE_BOOKING_CONTACT_BLOCK_ERROR_NAME;
  error.code = PRE_BOOKING_CONTACT_BLOCK_ERROR_CODE;
  error.status = 403;
  return error;
};

const CONTACT_PATTERNS = [
  {
    reason: 'email',
    regex: /\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b/i,
  },
  {
    reason: 'url',
    regex: /\b(?:https?:\/\/|www\.|(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+(?:com|net|org|io|co|app|dev|me|studio|photography|photo|agency|link|site|th|co\.th)\b)\S*/i,
  },
  {
    reason: 'maps_link',
    regex: /\b(?:google\s*maps|maps\.app\.goo\.gl|goo\.gl\/maps|maps\.google|g\.page\/)\b/i,
  },
  {
    reason: 'whatsapp',
    regex: /\b(?:whats\s*app|whatsapp|wa\s*(?:me|id|number|contact)?)\b/i,
  },
  {
    reason: 'line',
    regex: /\b(?:line\s*(?:id|account|app|me)|(?:my|on|via)\s+line|add\s+me\s+on\s+line)\b|\bline\s*[:：]\s*[@a-z0-9._-]{2,}/i,
  },
  {
    reason: 'social_handle',
    regex: /(^|[\s(["'])@[A-Za-z0-9._]{2,30}\b/i,
  },
  {
    reason: 'social_platform',
    regex: /\b(?:instagram|insta|ig|facebook|fb|tiktok|telegram|wechat|weixin|twitter)\s*(?:handle|id|account|@|:|me|dm)\b/i,
  },
  {
    reason: 'external_contact_phrase',
    regex: /\b(?:call|text|sms|email|dm)\s+me\b|\bcontact\s+me\s+(?:at|on|via|through)\b/i,
  },
  {
    reason: 'studio_contact',
    regex: /\b(?:my|our|the)\s+(?:studio|studios|space|venue)\s+(?:is|name is|called)\b|\b(?:studio|studios|space|venue)\s*(?:name|:|：)\b/i,
  },
  {
    reason: 'address',
    regex: /\b\d{1,6}\s+[\w\s.'-]{0,50}\b(?:street|st\.?|road|rd\.?|avenue|ave\.?|lane|ln\.?|drive|dr\.?|boulevard|blvd\.?|soi|alley|building|bldg\.?|apartment|apt\.?|unit|suite|floor|fl\.?|room)\b/i,
  },
  {
    reason: 'unit_or_floor',
    regex: /\b(?:unit|suite|apt|apartment|floor|fl|room|building|bldg)\s*(?:#|no\.?)?\s*[a-z]?\d[a-z0-9-]{0,7}\b/i,
  },
  {
    reason: 'location_context',
    regex: /\b(?:address|located\s+(?:at|in)|meet\s+at|come\s+to|near|pin)\b.{0,80}\b(?:bangkok|chiang\s+mai|phuket|pattaya|sukhumvit|silom|sathorn|thonglor|ekkamai|asok)\b/i,
  },
];

const phoneLikePattern = /(?:^|[^\w])(\+?\d[\d\s().-]{6,}\d)(?=$|[^\w])/g;

const containsPhoneLikePattern = message => {
  const text = String(message || '');
  let match = phoneLikePattern.exec(text);
  while (match) {
    const digitCount = (match[1].match(/\d/g) || []).length;
    if (digitCount >= 7) {
      phoneLikePattern.lastIndex = 0;
      return true;
    }
    match = phoneLikePattern.exec(text);
  }
  phoneLikePattern.lastIndex = 0;
  return false;
};

const detectPotentialContactInfo = message => {
  const text = String(message || '').trim();
  if (!text) {
    return { blocked: false, reasons: [] };
  }

  const reasons = CONTACT_PATTERNS.filter(pattern => pattern.regex.test(text)).map(
    pattern => pattern.reason
  );

  if (containsPhoneLikePattern(text)) {
    reasons.push('phone');
  }

  return {
    blocked: reasons.length > 0,
    reasons,
  };
};

const hasPotentialContactInfo = message => detectPotentialContactInfo(message).blocked;

const shouldBlockPreBookingMessage = ({ message, transaction, currentUser, senderUserId }) => {
  const contactSharingState = getBookingContactSharingState(transaction);
  return (
    contactSharingState.applies &&
    isTransactionParticipantSender({ transaction, currentUser, senderUserId }) &&
    !contactSharingState.hasBookingBeenConfirmed &&
    hasPotentialContactInfo(message)
  );
};

const shouldBlockPreBookingProcessMessage = ({ message, processName, processAlias }) => {
  const contactSharingState = getBookingContactSharingState({
    attributes: {
      processName: processAlias || processName,
    },
  });

  return (
    contactSharingState.applies &&
    !contactSharingState.hasBookingBeenConfirmed &&
    hasPotentialContactInfo(message)
  );
};

const shouldBlockProviderPreBookingMessage = shouldBlockPreBookingMessage;

module.exports = {
  PRE_BOOKING_CONTACT_BLOCK_ERROR_CODE,
  PRE_BOOKING_CONTACT_BLOCK_ERROR_MESSAGE,
  PRE_BOOKING_CONTACT_BLOCK_ERROR_NAME,
  createPreBookingContactBlockError,
  detectPotentialContactInfo,
  getBookingContactSharingState,
  hasPotentialContactInfo,
  isBookingConfirmedForContactSharing,
  isProviderSender,
  isTransactionParticipantSender,
  shouldBlockPreBookingMessage,
  shouldBlockPreBookingProcessMessage,
  shouldBlockProviderPreBookingMessage,
};
